<div id="box" [ngClass]="[type, customClass]">
  <ng-content></ng-content>
</div>
